"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupTimeSlotsColumns = void 0;
const groupTimeSlotsColumns = (_reservations) => {
    const reservationsBuffer = JSON.parse(JSON.stringify(_reservations));
    let resultReservations = [];
    reservationsBuffer.filter(r => r.activityTimeSlot !== undefined && r.activityTimeSlot !== null).reduce((r, o) => {
        var _a, _b, _c, _d, _e, _f;
        const key = o.activityTimeSlot;
        const item = r.get(key) || Object.assign({}, o, {
            o,
            people: o.people,
            options: o.options,
            customer: {
                firstname: 'Monit.' + (((_a = o.options) === null || _a === void 0 ? void 0 : _a.instructors) && ((_b = o.options) === null || _b === void 0 ? void 0 : _b.instructors.length) > 0 ? (_c = o.options) === null || _c === void 0 ? void 0 : _c.instructors[0] : '?'),
                lastname: '',
                name: 'Monit.' + (((_d = o.options) === null || _d === void 0 ? void 0 : _d.instructors) && ((_e = o.options) === null || _e === void 0 ? void 0 : _e.instructors.length) > 0 ? (_f = o.options) === null || _f === void 0 ? void 0 : _f.instructors[0] : '?')
            },
        });
        if (item.people && o._id !== item._id) {
            Object.keys(o.people || {}).forEach((key) => {
                item.people[key] = (item.people[key] || 0) + o.people[key];
            });
        }
        if (item.options && o._id !== item._id) {
            Object.keys(o.options.equipments || {}).forEach((key) => {
                let equipments = item.options.equipments || { type: 'canoe', customized: false };
                if (key !== "type" && key !== "customized") {
                    const oEquipmentCount = (o.options.equipments &&
                        o.options.equipments[key] &&
                        o.options.equipments.type === "canoe") ? o.options.equipments[key] : 0;
                    const itemEquipmentCount = (item.options.equipments &&
                        item.options.equipments[key]) ? item.options.equipments[key] : 0;
                    equipments[key] = itemEquipmentCount + oEquipmentCount;
                }
            });
            if (o.options.peopleAtArrivalCount) {
                item.options.peopleAtArrivalCount = (item.options.peopleAtArrivalCount || 0) +
                    o.options.peopleAtArrivalCount;
            }
        }
        if (!r.get(key)) {
            resultReservations.push(item);
        }
        return r.set(key, item);
    }, new Map()).values();
    return resultReservations;
};
exports.groupTimeSlotsColumns = groupTimeSlotsColumns;
//# sourceMappingURL=groupTimeSlotsColumns.js.map